import { styled } from "styled-components";

import { HeadingEl } from "../../structures/heading";

export const Container = styled.div<{ $tight?: boolean }>`
  padding: ${({ $tight }) => ($tight ? "1rem;" : "3rem")};
  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const Card = styled(Container)<{ $tight?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colours.bordersLight};
  background: ${({ theme }) => theme.colours.white};
  border-radius: 6px;
  ${HeadingEl} {
    padding-bottom: 0.5rem;
    border-bottom: 1px solid ${(props) => props.theme.colours.bordersLight};
    margin-bottom: 1rem;
  }
`;
